"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Furigana = {
    elemName: '振り仮名',
    type: 'inline',
    doc: '振り仮名を挿入します。"｜"でかなを区切ると、両側ルビのように左右にかなが表示されます。漢文の再読文字もこの方式で入力します。',
    example: '未（いまだ｜ズ）',
    minContentCount: 2,
    maxContentCount: 3,
    textTemplate: '{{$text}}',
    htmlTemplate: `
	<ruby class="Furigana {{$classes}}" {{{$htmlId}}} >
		{{{$1}}}
		<rt class="furigana-right">{{{$2}}}</rt>
		{{#$3}}
		<rtc class="furigana-left">{{{$3}}}</rtc>
		{{/$3}}
	</ruby>
	`,
    xmlTemplate: `
	<span type="ruby" {{{$xmlId}}} {{{$xmlSubtypes}}}>		
		<span type="rb">{{{$1}}}</span>
		<span type="rt" rend="right">{{{$2}}}</span>
		{{#$3}}
		<span type="rt" rend="left">{{{$3}}}</span>
		{{/$3}}
	</span>
	`,
    docxTemplate: `
			<w:r>
                <w:fldChar w:fldCharType="begin"/>
            </w:r>
            <w:r>
                <w:instrText xml:space="preserve"></w:instrText>
            </w:r>
            <w:r>
                <w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                </w:rPr>
                <w:instrText>eq \\o\\ad(\\s\\up 9(</w:instrText>
            </w:r>
			<w:r>
                <w:rPr>
					<w:rFonts w:hint="eastAsia"/>
                    <w:sz w:val="10"/>
                </w:rPr>
                <w:instrText>{{{$$2}}}</w:instrText>
            </w:r>
			{{#$3}}
			<w:r>
                <w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                </w:rPr>
                <w:instrText>),\\s\\do 9(</w:instrText>
            </w:r>
			<w:r>
                <w:rPr>
					<w:rFonts w:hint="eastAsia"/>
                    <w:sz w:val="10"/>
                </w:rPr>
                <w:instrText>{{{$$3}}}</w:instrText>
            </w:r>
			{{/$3}}
			<w:r>
                <w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                </w:rPr>
                <w:instrText>),{{{$$1}}})</w:instrText>
            </w:r>
            <w:r>
                <w:fldChar w:fldCharType="end"/>
            </w:r>
	`,
    latexTemplate: '{{#$3}}\\HidariNakaTn{ {{/$3}}\\MigiNakaTn{ {{{$1}}} }{ {{{$2}}} }{{#$3}} }{ {{{$3}}} }{{/$3}}'
};
exports.default = Furigana;
// 	toXML(node: KojiASTNode): string {
// 		// see https://github.com/TEI-EAJ/jp_guidelines/wiki/%E3%83%AB%E3%83%93
// 		const text = this.converter.convertChildren(node.children);
// 		const right = this.converter.convertChildren(node.extra[0]);
// 		if (node.extra[1]) {
// 			const left = this.converter.convertChildren(node.extra[1]);
// 			return `<span type="ruby">
//                      <span type="rb" >${text}</span>
//                      <span type="rt" rend="right">${right}</span>
//                      <span type="rt" rend="left">${left}</span>
//                    </span>`;
// 		} else {
// 			return `<span type="ruby">
//                      <span type="rb">${text}</span>
//                      <span type="rt" rend="right">${right}</span>
//                    </span>`;
// 		}
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		const right = this.converter.convertChildren(node.extra[0]);
// 		if (node.extra[1]) {
// 			const left = this.converter.convertChildren(node.extra[1]);
// 			return `${text}（${right}｜${left}）`;
// 		} else {
// 			return `${text}（${right}）`;
// 		}
// 	}
// 	toHTML(node: KojiASTNode) {
// 		const text = this.converter.convertChildren(node.children);
// 		const right = this.converter.convertChildren(node.extra[0]);
// 		if (node.extra[1]) {
// 			const left = this.converter.convertChildren(node.extra[1]);
// 			return `
//             <ruby class="Furigana">
//                 ${text}<rt class="right">${right}</rt>
//                 <rt class="left">${left}</rt>
//             </ruby>
//           `;
// 		} else {
// 			return `
//             <ruby class="Furigana">
//                 ${text}<rt>${right}</rt>
//             </ruby>
//           `;
// 		}
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVyaWdhbmEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9GdXJpZ2FuYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLE1BQU0sUUFBUSxHQUFtQjtJQUNoQyxRQUFRLEVBQUUsTUFBTTtJQUNoQixJQUFJLEVBQUUsUUFBUTtJQUNkLEdBQUcsRUFBRSxpRUFBaUU7SUFDdEUsT0FBTyxFQUFFLFVBQVU7SUFDbkIsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFdBQVc7SUFDekIsWUFBWSxFQUFFOzs7Ozs7OztFQVFiO0lBQ0QsV0FBVyxFQUFFOzs7Ozs7OztFQVFaO0lBQ0QsWUFBWSxFQUFFOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztFQTRDYjtJQUNELGFBQWEsRUFBRSxnR0FBZ0c7Q0FDL0csQ0FBQztBQUVGLGtCQUFlLFFBQVEsQ0FBQztBQUV4QixzQ0FBc0M7QUFDdEMsNEVBQTRFO0FBQzVFLGdFQUFnRTtBQUNoRSxpRUFBaUU7QUFDakUseUJBQXlCO0FBQ3pCLGlFQUFpRTtBQUNqRSxnQ0FBZ0M7QUFDaEMsdURBQXVEO0FBQ3ZELG9FQUFvRTtBQUNwRSxrRUFBa0U7QUFDbEUsK0JBQStCO0FBQy9CLGFBQWE7QUFDYixnQ0FBZ0M7QUFDaEMsc0RBQXNEO0FBQ3RELG9FQUFvRTtBQUNwRSwrQkFBK0I7QUFDL0IsTUFBTTtBQUNOLEtBQUs7QUFFTCx1Q0FBdUM7QUFDdkMsZ0VBQWdFO0FBQ2hFLGlFQUFpRTtBQUNqRSx5QkFBeUI7QUFDekIsaUVBQWlFO0FBQ2pFLHlDQUF5QztBQUN6QyxhQUFhO0FBQ2IsaUNBQWlDO0FBQ2pDLE1BQU07QUFDTixLQUFLO0FBRUwsK0JBQStCO0FBQy9CLGdFQUFnRTtBQUNoRSxpRUFBaUU7QUFDakUseUJBQXlCO0FBQ3pCLGlFQUFpRTtBQUNqRSxjQUFjO0FBQ2Qsc0NBQXNDO0FBQ3RDLHlEQUF5RDtBQUN6RCxnREFBZ0Q7QUFDaEQsc0JBQXNCO0FBQ3RCLGVBQWU7QUFDZixhQUFhO0FBQ2IsY0FBYztBQUNkLHNDQUFzQztBQUN0QywyQ0FBMkM7QUFDM0Msc0JBQXNCO0FBQ3RCLGVBQWU7QUFDZixNQUFNO0FBQ04sS0FBSztBQUNMLElBQUkifQ==